import React, { useState } from "react";
import "./contactForm.css";
import Header from "../../components/Header/header";
import Footer from "../../components/Footer/footer";
import Icons from "../../config/images";
import { addContactUsAPI } from "../../store/action/contactAction";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Strings from "../../config/Strings";

const ContactForm = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormData({ name: "", mobile: "", email: "", message: "" });
    const requestData = {
      user_name: formData?.name,
      user_mobile_number:formData?.mobile,
      user_email: formData?.email,
      message:formData?.message,
  }

  try {
    await dispatch(
      addContactUsAPI(requestData, (isSuccess, result) => {
        if (isSuccess.status) {
          toast.success(result?.message?.message);
        } else {
          toast.error(
            result?.error?.message || Strings.somethingWentWrongError
          );
        }
      })
    );
  } catch (error) {
    console.error("Error updating user status:", error);
    toast.error(Strings.somethingWentWrongError);
  }
  };

  return (
    <>
      <Header />

      <div className="contact-container">
        <div className="contact-text">
          <div>
            <p className="text-parent-container-style">
              <span className="contact-bold-text-style----">
                Innovative Solutions to Turn Your Ideas into Reality
              </span>
            </p>

            <p className="text-parent-light-container-style">
              <span className="contact-light-text-style">
                {" "}
                Our mission is to help visionary brands transform ideas into
                cutting-edge digital solutions that engage and delight.
              </span>
            </p>

            <p className="text-parent-light-container-style">
              <span className="contact-light-text-style">
                {" "}
                We partner with leading brands to create innovative digital
                solutions that captivate audiences and drive success. From
                seamless interfaces to robust platforms, we turn ideas into
                impactful experiences.
              </span>
            </p>
          </div>
        </div>

        {/* Right Side Contact Form with Absolute Positioning */}
        <div className="contact-form">
          <span className="contact-form-modal-light-text-style">
            Connect with <span className="contact-form-modal-bold-text-style">Our Expert</span>
          </span>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="mobile"
              placeholder="Mobile Number"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email Id"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              required
            />
            <button type="submit" className="submit-button-view">Submit</button>
          </form>
        </div>
      </div>

      <div className="confidentiality">
        <div className="contact-form-verified-text-view">
          <img
            src={Icons.verifiedIcon}
            className="contact-form-verified-icon"
            alt="verified-icon"
          />
          All projects are protected by NDAs and IPs.{" "}
          <strong>100% Confidential.</strong>
        </div>
      </div>

      <div className="contact-footer">
        <div className="address">
          📍 203, Simni Chamber, Luhar Ni Pole, Maneckchowk, Ahmedabad
        </div>
        <div className="contact-numbers">
          📞 76917 86322 &nbsp;&nbsp; 📞 76917 86322
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ContactForm;
